<template>
    <div class="card summary-item col-12" v-bind:class="[ uselistinglayout ? 'card--list-layout' : 'col-lg-4' ]">
        <a v-bind:href="item.Url" class="card-content-wrapper card-link-wrapper" v-bind:class="'card-link-wrapper-' + item.ListingCardDisplayType">
            <div class="card-body">

                <div role="img"
                     class="card-media"                     
                     v-bind:aria-label="item.DisplayAriaLabel"
                     v-bind:style="{ 'background-image': 'url(' + image + ')' }"></div>

                <div class="card-body-content-wrapper">

                    <div v-if="item.ListingCardDisplayTag"
                         class="card-tags">

                        <span class="card-tags-item"
                              v-bind:class="'card-tags-item-' + item.ListingCardDisplayType"
                              >{{ item.ListingCardDisplayTag }}</span>

                    </div>

                    <h2 class="card-title" v-bind:class="[ item.ListingCardDisplayTag ? 'card-w-type': 'card-no-type']">
                        {{ item.Title }}
                    </h2>

                    <div v-if="uselistinglayout" class="card-text">
                        {{ item.Summary }}
                    </div>
                </div>

                <div class="card-cta">
                    <div class="m-0 link"
                         v-bind:class="[ item.Type.CodeName.toLowerCase() ]">
                        {{ item.Cta.Text }}
                    </div>
                </div>
            </div>
        </a>
    </div>
</template>

<script>
    import imageOptimizer from '../../utils/image-optimizer';

	export default {
		props: ['item', 'uselistinglayout'],
		components: {

        },
        computed: {
            types: function () {
				return this.item.Tags.filter((item) => {
					return item.Type.CodeName == 'Types';
				}).slice(0, 2);
            },
            topics: function () {
				return this.item.Tags.filter((item) => {
					return item.Type.CodeName == 'Topics';
				}).slice(0, 1);
            },
            image: function () {
                let html = document.querySelector('html');

                if (html.classList.contains('webp')){
                    if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getOptimizedImageUrl(this.item.Image, 'webp');
                    }
                    else {
                        return '/content/images/content-placeholder.webp';
                    }
                }
                else {
                    if (this.item.Image !== null && this.item.Image !== "") {
                        return imageOptimizer.getSanitizeMediaUrl(this.item.Image);
                    }
                    else {
                        return '/content/images/content-placeholder.png';
                    }
                }
            }
        },
		mounted: function () {
		},
		methods: {
        },
    }
</script>